package model

import kotlinx.serialization.Serializable

@Serializable
data class StoresNearbyRequestBody(
    val userLocation: GeoPoint,
    val maxAllowedMeters: Double = NEAR_ME_RADIUS_METERS,
    val limit: Int = 50
)
